module.exports = __webpack_public_path__ + "img/deer.f241cfc9.svg";